import React from 'react';
import { Typography } from '@mui/material';
import FormattedText from './FormattedText';
import useMessageStyles from '../../../hooks/useMessageStyles';

export default function FallbackMessage({ message }) {
  const { messageSecondaryTextSx } = useMessageStyles();

  if (message.text) {
    return <FormattedText text={message.text} />;
  }

  return (
    <Typography component="div" sx={{ ...messageSecondaryTextSx, fontStyle: 'italic' }}>
      [{message.rawType || message.kind || 'Unsupported message'}]
    </Typography>
  );
}
